<template>
  <div class="system_message flex flexcolumn Flexjustify">
    <!-- <div class="theme_box" ref="content">
      <div class="theme_one flex FlexBetween" v-for="(item, index) in themeList" :key="index">
        <div class="theme_one_right flex-1">
          <div class="flex Flexalign">
            <div class="theme_one_left">
              <el-image class="avatar" :src="iconPath(item.avatar)"></el-image>
            </div>
            <div class="flex Flexalign FlexBetween right_top flex-1 mar_left_15">
              <div class="flex Flexalign">
                <div class="theme_name">{{ item.name }}</div>
              </div>
              <div class="theme_updateTime">{{ item.updateTime }}</div>
            </div>
          </div>
          <div class="theme_content mar_top_10">{{ item.content }}</div>
          <div class="reply_content flex">
            <el-image class="content_img" :src="imgPath(item.contentImg)"></el-image>
            <div class="reply_info flex-1">
              <div class="replyer_name">@{{ item.replyer }}</div>
              <div class="reply_text">{{ item.replyContent }}</div>
            </div>
          </div>
          <div class="right_bottom mar_top_15 flex Flexalign FlexBetween">
            <div class="">
              <span class="theme_source">来自课程：</span><span class="theme_region">{{ item.source }}</span>
            </div>
            <div class="reply_box flex Flexalign">
              <el-image class="reply_img" :src="imgPath('reply_icon.png')"></el-image>
              <div class="reply_text">{{ item.discussNum }}</div>
              <div class="split_line"></div>
              <el-image class="reply_img" :src="imgPath('liked_icon.png')"></el-image>
              <div class="reply_text">{{ item.likeNum }}</div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <moe-empty url="development_icon_gray.png" emptyText="功能开发中，敬请期待"></moe-empty>
  </div>
</template>

<script>
export default {
  name: "GjkcH5Comment",

  data() {
    return {
      themeList: [
        {
          avatar: "user_avatar.png",
          name: "小杨同学",
          isMember: true,
          updateTime: "2024-12-19 22:11",
          content: "这个课程，三角形内角分为哪几种类型，还不是很清楚。",
          contentImg: "video_img.png",
          source: "高等函数",
          replyer: "小李爱学习",
          replyContent:
            "评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容",
          discussNum: 12,
          likeNum: 32,
        },
        {
          avatar: "user_avatar.png",
          name: "小杨同学",
          isMember: true,
          updateTime: "2024-12-19 22:11",
          content: "这个课程，三角形内角分为哪几种类型，还不是很清楚。",
          contentImg: "video_img.png",
          source: "高等函数",
          replyer: "小李爱学习",
          replyContent:
            "评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容",
          discussNum: 12,
          likeNum: 32,
        },
        {
          avatar: "user_avatar.png",
          name: "小杨同学",
          isMember: true,
          updateTime: "2024-12-19 22:11",
          content: "这个课程，三角形内角分为哪几种类型，还不是很清楚。",
          contentImg: "video_img.png",
          source: "高等函数",
          replyer: "小李爱学习",
          replyContent:
            "评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容",
          discussNum: 12,
          likeNum: 32,
        },
        {
          avatar: "user_avatar.png",
          name: "小杨同学",
          isMember: true,
          updateTime: "2024-12-19 22:11",
          content: "这个课程，三角形内角分为哪几种类型，还不是很清楚。",
          contentImg: "video_img.png",
          source: "高等函数",
          replyer: "小李爱学习",
          replyContent:
            "评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容评论内容",
          discussNum: 12,
          likeNum: 32,
        },
      ],
    };
  },

  mounted() { },

  methods: {},
};
</script>
<style lang="scss" scoped>
.system_message {
  width: 1000px;
  height: 780px;
  background: #ffffff;
  border-radius: 10px;
}
.theme_box {
  width: 649px;
  background: #ffffff;
  border-radius: 10px;
  padding: 0 20px;
  box-sizing: border-box;

  .theme_one {
    border-top: 1px solid rgba(20, 20, 20, 0.1);
    padding: 20px 0;

    .theme_one_left {
      .avatar {
        width: 48px;
        height: 48px;
        border-radius: 50%;
      }
    }

    .theme_one_right {
      margin-left: 15px;

      .right_top {
        .theme_name {
          color: #999999;
        }

        .member_logo {
          width: 72px;
          height: 28px;
          margin-left: 20px;
        }

        .theme_updateTime {
          color: #999999;
        }
      }

      .theme_content {
        color: #333333;
        font-weight: 600;
      }

      .reply_content {
        margin-top: 10px;
        width: 100%;
        height: 89px;
        background: #f5f6f8;
        border-radius: 10px;

        .content_img {
          height: 89px;
          width: 105px;
        }

        .reply_info {
          padding: 0 15px;
          box-sizing: border-box;
          color: #666666;

          .replyer_name {
            line-height: 38px;
          }

          .reply_text {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
      }

      .right_bottom {
        .theme_source {
          color: #999999;
        }

        .theme_region {
          color: rgba(19, 214, 170, 1);
        }

        .reply_box {
          color: rgba(153, 153, 153, 1);

          .reply_img {
            width: 24px;
            height: 24px;
          }

          .split_line {
            margin: 0 12px;
            width: 1px;
            height: 20px;
            background: #141414;
            opacity: 0.1;
          }

          .reply_text {
            margin-left: 6px;
          }

          .delete_text {
            color: rgba(255, 102, 25, 1);
          }
        }
      }
    }
  }
}
</style>